
import React, { useState, useEffect } from 'react';
import {
    BtnBold,
    BtnItalic,
    BtnUnderline,
    BtnLink,
    Editor,
    EditorProvider,
    Toolbar
} from 'react-simple-wysiwyg';
import { checkText } from 'smile2emoji';

const HtmlEditor = ({ value: externalValue, onChange, ...props }) => {
    const [value, setValue] = useState(externalValue || '');

    useEffect(() => {
        setValue(externalValue || '');
    }, [externalValue]);

    const isLinkStartWithHttps = (url) => {
        const pattern = /^https:\/\/.*/;
        return pattern.test(url);
    };

    function handleChange(e) {

        const parser = new DOMParser();
        const doc = parser.parseFromString(e.target.value, 'text/html');
        const links = doc.querySelectorAll('a');

        links.forEach(link => {
            const href = link.getAttribute('href');
            if (!isLinkStartWithHttps(href)) {
                link.setAttribute('href', `https://${href.replace("http://", '')}`);
            }
        });

        // Convert back to text/html
        const updatedContent = doc.body.innerHTML;

        const inputValue = updatedContent.replace(/&nbsp;/g, ' ');
        const replacedEmojiString = checkText(inputValue);
        const replacedAtagWithTarget = replacedEmojiString.replace(/<a\s+(?![^>]*\btarget="_blank")/g, '<a target="_blank" ');
        setValue(replacedAtagWithTarget);
        if (onChange) {
            onChange(replacedAtagWithTarget);
        }
    }

    return (
        <EditorProvider>
            <Editor
                value={value}
                onChange={handleChange}
                {...props}
            >
                <Toolbar>
                    <BtnBold />
                    <BtnItalic />
                    <BtnUnderline />
                    <BtnLink />
                </Toolbar>
            </Editor>
        </EditorProvider>
    );
};

export default HtmlEditor;
